<div class="w-full h-full flex justify-center mt-[8%]">
  <div class="text-center">
    <img *ngIf="showImg" src="https://iti-images.s3.amazonaws.com/imgs/no-data-city-line.png" alt="" />
    <div class="text-center text-gray-300 text-4xl font-semibold mt-8" [class]="textCls">{{ message }}</div>
  </div>
</div>